import React from 'react';
import styled from 'styled-components';

import { CtaButton } from '../styled';

const CurrencyHeroContainer = styled.div`
  background: #08111e;
  color: white;
  text-align: center;
  padding: 110px 25px 90px;
`;

const MainImage = styled.div`
  img {
    height: 210px;
    margin-bottom: 40px;
    border-radius: 210px;
  }
`;

const CurrencyName = styled.div`
  font-size: 48px;
  line-height: 48px;
  font-weight: 600;
`;

const Headline = styled.div`
  font-size: 24px;
  font-weight: 300;
  line-height: 32px;
  max-width: 474px;
  margin: 25px auto 25px;
`;

const SecondaryCTA = styled.div`
  margin: 25px auto;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;

  a {
    color: white;
    text-decoration: none;

    &:hover {
      color: #dddddd;
      cursor: pointer;
    }

    &:active {
      color: #aaaaaa;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

const CurrencyInfo = styled.div`
  display: flex;
  max-width: 660px;
  margin: 150px auto 0;
  border: 1px solid rgba(186, 189, 194, 0.12);
  border-radius: 6px;
`;

const CurrencyInfoItem = styled.div`
  flex: 1;
  border-right: 1px solid rgba(186, 189, 194, 0.12);
  padding: 24px 0;

  &:last-child {
    border-right: none;
  }
`;

const ItemHeader = styled.div`
  color: #babdc2;
  font-size: 12px;
  line-height: 36px;
  text-transform: uppercase;
`;

const ItemLabel = styled.div`
  font-size: 36px;
  font-weight: 600;

  a {
    color: white;
    text-decoration: none;

    &:hover {
      color: #dddddd;
    }

    &:active {
      color: #aaaaaa;
    }
  }

  @media (max-width: 420px) {
    font-size: 24px;
  }
`;

function CurrencyHero({ input }) {
  return (
    <CurrencyHeroContainer>
      <MainImage><img src={input.primary.icon.url} /></MainImage>
      <CurrencyName>{input.primary.currency_name.text}</CurrencyName>
      <Headline>{input.primary.headline.text}</Headline>
      <div>
        
      </div>
      {input.primary.secondary_cta_link &&
        <SecondaryCTA><a href={input.primary.secondary_cta_link.url}>{input.primary.secondary_cta.text}</a></SecondaryCTA>
      }
      {input.primary.market_cap.text && (
        <CurrencyInfo>
          <CurrencyInfoItem>
            <ItemHeader>Market Cap</ItemHeader>
            <ItemLabel>{input.primary.market_cap.text}</ItemLabel>
          </CurrencyInfoItem>
          <CurrencyInfoItem>
            <ItemHeader>30 Day Volume</ItemHeader>
            <ItemLabel>{input.primary.volume.text}</ItemLabel>
          </CurrencyInfoItem>
          <CurrencyInfoItem>
            <ItemHeader>Proof of Funds</ItemHeader>
            <ItemLabel>
              {input.primary.proof_of_funds_link &&
                <a href={input.primary.proof_of_funds_link.url} target="_blank" rel="noopener noreferrer">
                  {input.primary.proof_of_funds.text}
                </a>
              }
              {!input.primary.proof_of_funds_link &&
                input.primary.proof_of_funds.text
              }
            </ItemLabel>
          </CurrencyInfoItem>
        </CurrencyInfo>
      )}
    </CurrencyHeroContainer>
  );
}

export { CurrencyHero };
